import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './CategorySwitcher.css';

// Antes esto era un <button onClick> que llamaba a navigate() -- sin
// ningún <a href> en el DOM, un crawler que solo sigue links reales
// (no todos ejecutan JS) nunca encontraba /coleccion/bautismo ni
// /coleccion/comunion, y por lo tanto tampoco los productos de comunión
// (que solo se linkean desde esa página) -- confirmado por un audit real
// que las marcó como "orphaned pages" pese a estar en el sitemap.
export default function CategorySwitcher({ selectedCategory }) {
  const categories = ['Bautismo', 'Comunion'];

  return (
    <section className="category-switcher">
      <div className="category-switcher__tabs">
        {categories.map((cat) => (
          <Link
            key={cat}
            to={`/coleccion/${cat.toLowerCase()}`}
            className={`category-switcher__tab ${selectedCategory === cat ? 'is-active' : ''}`}
          >
            {cat.toUpperCase()}
          </Link>
        ))}
      </div>
    </section>
  );
}

CategorySwitcher.propTypes = {
  selectedCategory: PropTypes.string.isRequired,
};
